import React, { useEffect, useState } from 'react';
import {
  AiOutlineEdit,
  AiOutlineCloseCircle,
  AiOutlineSave,
} from 'react-icons/ai';

export const ProfileAttribute = ({
  name,
  type,
  value,
  setValue,
  setSave,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [inputValue, setInputValue] = useState(value);
  const [error, setError] = useState(false);

  const validateEmail = (email) => {
    return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);
  };
  const validataPhone = (phone) => {
    return phone;
  };
  const validateZipCode = (zipCode) => {
    return /^[0-9]{5}$/.test(zipCode);
  };

  const setErrorMessage = () => {
    if (type === 'email') {
      return 'Bitte geben Sie eine gültige E-Mail-Adresse ein.';
    }
    if (type === 'phone') {
      return 'Bitte geben Sie eine gültige Telefonnummer ein.';
    }
    if (type === 'zipCode') {
      return 'Bitte geben Sie eine gültige Postleitzahl ein.';
    }
    return 'Bitte Eintrag überprüfen.';
  };

  const setErrorDisplay = () => {
    if (error) {
      return ' border-red focus:border-red focus:ring-red';
    } else {
      return ' border-indigo-300 focus:border-indigo-300 focus:ring-indigo-200';
    }
  };

  const handleSave = () => {
    const isEmailValid = type === 'email' && !validateEmail(inputValue);
    const isPhoneValid = type === 'phone' && !validataPhone(inputValue);
    const isZipCodeValid = type === 'zipCode' && !validateZipCode(inputValue);
    setError(isEmailValid || isPhoneValid || isZipCodeValid);
    if (isEmailValid || isPhoneValid || isZipCodeValid) return;

    setIsEditing(false);
    setValue(inputValue);
    setSave(true);
  };

  const handleCancel = () => {
    setIsEditing(false);
    setError(false);
    setInputValue(value);
  };

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  return (
    <div className="px-4  flex sm:px-0">
      <dt className="text-sm font-medium sm:col-span-2  mt-1  w-[200px] leading-6 text-gray-900">
        {name}
      </dt>
      {isEditing ? (
        <>
          <div className="sm:col-span-3 block w-full">
            <input
              type="text"
              className={
                'w-full rounded-md border-1 focus:ring ' +
                'focus:ring-opacity-50 sm:text-sm  ' +
                `${setErrorDisplay()}`
              }
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
            />
            <div className="flex flex-row h-6 w-full">
              {error && (
                <p className="text-red pl-1 pt-1 text-xs">{setErrorMessage()}</p>
              )}
            </div>
          </div>
          <div className="flex flex-row justify-end ml-4 -mt-5  mr-10">
            <button className="block border-0" onClick={handleSave}>
              <AiOutlineSave className="h-6 w-6 text-gray-600" />
            </button>
            <button className="block border-0" onClick={handleCancel}>
              <AiOutlineCloseCircle className="h-6 w-6 text-gray-600" />
            </button>
          </div>
        </>
      ) : (
        <>
          <div className="sm:col-span-3 -m-1 block w-full">
            <input
              type="text"
              className={
                'sm:col-span-3 block w-full rounded-md border-1 ' +
                'border-[transparent] focus:border-[transparent] ' +
                'focus:ring-0 sm:text-sm m-1 ' +
                `${value || inputValue ? 'text-gray-700' : 'text-gray-500'}`
              }
              value={value ? value : ''}
              readOnly={true}
            />
            <div className="flex flex-row justify-end h-6 w-full"></div>
          </div>
          <div className="flex flex-row h-6 justify-end mr-10">
            <button
              className="block border-0"
              onClick={() => setIsEditing(!isEditing)}
            >
              <AiOutlineEdit className="h-6 w-6 text-gray-600" />
            </button>
          </div>
        </>
      )}
    </div>
  );
}